import React from 'react';
import { Button } from '@lana-ui/login';
import Divider from '../../Common/common/src/divider/Divider.jsx';
import "../../../Statics/Scss/Features/ModalBodyConfirmarDomicilio.scss"
import "../../../Statics/Scss/Base/Helpers.scss"
import CallbackArticle from '../../Common/login/src/callbackArticle/CallbackArticle.jsx';
import Paragraph from '../../Common/common/src/paragraph/Paragraph.jsx';

const ModalBodyConfirmarDomicilio = (props) => {
    const { nuevoDomicilio, confirmarCambio, modificarDomicilio } = props;
    const detalleDomicilio = `${nuevoDomicilio.EditarDomicilio.calle} ${nuevoDomicilio.EditarDomicilio.altura} ${nuevoDomicilio.EditarDomicilio.localidad} - ${nuevoDomicilio.EditarDomicilio.provincia} CP ${nuevoDomicilio.EditarDomicilio.cp}`;
    return (
        <div className='container-modal-confirmar-domicilio'>
            <div className='row --jc-center'>
                <CallbackArticle
                    font="sueca"
                    className="--font-regular"
                    title={
                        <div className="col-deskxl-12 col-desksm-9">
                            Estás por agregar el domicilio:
                        </div>
                    }
                    description={
                        <div className="col-deskxl-11 col-deskxl-12">
                            <Paragraph size="threexs">{detalleDomicilio}</Paragraph>
                        </div>
                    }
                />
            </div>
            <Divider />
            <div className="row-gap-tablet-2">
                <Button tag="input" className="--not-disabled" label="CONFIRMAR" type="button" onClick={confirmarCambio} mobileW100={true} />
                <Button mod="secondary" className="--background-gray" tag="input" label="MODIFICAR DOMICILIO" onClick={modificarDomicilio} type="button" mobileW100={true} />
            </div>
        </div>
    );
};

export default ModalBodyConfirmarDomicilio;
